export const isGoodCampaign = (revenue, price) => parseFloat(revenue) >= price;
